import styles from '../TargetGroupTable.module.css';
import React from 'react';
import {
    AnalysisAPI,
    ReportAPI,
} from '../../../../typings/participant_activity';

interface CandidateReportStatusProps {
    report?: ReportAPI;
    analysis?: AnalysisAPI;
    hasErrorStatus: boolean;
    participantEmail?: string;
    groupType?: string;
    hasStarted?: boolean;
}

const CandidateReportStatus: React.FunctionComponent<
    CandidateReportStatusProps
> = (props) => {
    const {
        report,
        analysis,
        hasErrorStatus,
        participantEmail,
        groupType,
        hasStarted,
    } = props;

    const isAnonymousSnapFit = !participantEmail && groupType === 'SNAP_FIT';
    const prewarmLikelyNotStarted =
        hasStarted === false ||
        (hasStarted === undefined && groupType === 'SNAP_FIT');
    const showAnalysing =
        !report &&
        analysis?.status === 'pending' &&
        !hasErrorStatus &&
        !prewarmLikelyNotStarted;
    const showNotStartedForPending =
        !report &&
        analysis?.status === 'pending' &&
        !hasErrorStatus &&
        prewarmLikelyNotStarted;

    return (
        <>
            {!!report && analysis?.status !== 'pending' && (
                <span
                    className={styles.status_wrapper}
                    style={{
                        backgroundColor: '#1AA277',
                    }}>
                    Completed
                </span>
            )}

            {!!report && analysis?.status === 'pending' && (
                <span
                    className={styles.status_wrapper}
                    style={{
                        backgroundColor: '#1AA277',
                    }}>
                    Partially completed
                </span>
            )}

            {!report && analysis?.status === 'done' && isAnonymousSnapFit && (
                <span
                    className={styles.status_wrapper}
                    style={{
                        backgroundColor: '#1AA277',
                    }}>
                    Completed
                </span>
            )}

            {showAnalysing && (
                <span
                    className={styles.status_wrapper}
                    style={{
                        backgroundColor: 'rgba(95, 145, 204, 1)',
                    }}>
                    Analysing
                </span>
            )}

            {!report && analysis?.status === 'pending' && hasErrorStatus && (
                <span
                    className={styles.status_wrapper}
                    style={{
                        backgroundColor: '#F6510E',
                    }}>
                    Failed
                </span>
            )}

            {(!report && !analysis) || showNotStartedForPending ? (
                <span
                    className={styles.status_wrapper}
                    style={{
                        backgroundColor: '#BBC9D8',
                    }}>
                    Not started
                </span>
            ) : null}
        </>
    );
};

export default CandidateReportStatus;
